import './MinimalStepper.scss';

export type MinimalStepperProps = {
    steps: {
        label: string;
        status: 'completed' | 'inProgress' | 'pending';
    }[];
};

export const MinimalStepper: React.FC<MinimalStepperProps> = ({ steps }) => {
    return (
        <div className="minimal-stepper">
            {steps.map((step) => (
                <div key={step.label} className={`minimal-stepper-step ${step.status}`}></div>
            ))}
        </div>
    );
};
